import { Suspense } from "react";
import { ROUTES } from "../constants";
import { Routes, Route } from "react-router-dom";
import { PrivateRoute } from "../context/routes/privateRoutes";

// Other imports...
import Onboarding from "../../components/onboarding";
import { isLoggedIn } from "../context/authContext";
import Login from "../../pages/authentication/login";
import ContractRoute from "../context/routes/contractRoues";
import ContractProvider from "../../providers/contract/contract.provider";
import BusinessHome from "../../pages/business/home";
import CreateContract from "../../pages/business/create";
import Contracts from "../../pages/business/contracts";
import BusinessSettings from "../../pages/business/settings";
import BusinessUsers from "../../pages/business/users";
import BusinessUserProfile from "../../pages/business/userProfile";
import BusinessUpdates from "../../pages/business/updates";
import { AuthConfig } from "../context/config/authConfig";
import BusinessBalance from "../../pages/business/balance";
import { WalletProvider } from "../../providers/wallet/wallet.provider";
import BusinessTransactions from "../../pages/business/transactions";
import SettlementDetails from "../../pages/settlements/SettlementDetails";

export const IndexRouter = () => {
  const authorities = AuthConfig.getUserInfo()?.authorities;

  return (
    <Suspense fallback={<div />}>
      <Routes>
        {/* Public and private routes */}
        <Route
          path={ROUTES.HOME}
          element={isLoggedIn() ? <BusinessHome /> : <Login />}
        />
        <Route path={ROUTES.ONBOARDING} element={<Onboarding />} />
        {(authorities?.includes("CLIENT_ADMIN_CREATE_CONTRACT") ||
          authorities?.includes("CLIENT_ADMIN") ||
          authorities?.includes("ORGANIZATION_OWNER")) && (
          <Route
            path={ROUTES.CREATE_COMPLEX_CONTRACT}
            element={<PrivateRoute />}>
            <Route index element={<CreateContract />} />
            <Route path=":id?" element={<CreateContract />} />
          </Route>
        )}
        <Route path={ROUTES.CONTRACTS_LIST} element={<PrivateRoute />}>
          <Route path={ROUTES.CONTRACTS_LIST} element={<Contracts />} />
        </Route>
        <Route path={ROUTES.LATEST_UPDATES} element={<PrivateRoute />}>
          <Route path={ROUTES.LATEST_UPDATES} element={<BusinessUpdates />} />
        </Route>
        <Route path={ROUTES.BALANCE} element={<PrivateRoute />}>
          <Route
            path={ROUTES.BALANCE}
            element={
              <WalletProvider>
                <BusinessBalance />
              </WalletProvider>
            }
          />
        </Route>
        <Route path={ROUTES.MONEY_TRANSACTIONS} element={<PrivateRoute />}>
          <Route
            path={ROUTES.MONEY_TRANSACTIONS}
            element={
              <WalletProvider>
                <BusinessTransactions />
              </WalletProvider>
            }
          />
        </Route>
        <Route path={ROUTES.CONTRACT_DETAILS} element={<PrivateRoute />}>
          <Route
            path={ROUTES.CONTRACT_DETAILS}
            element={
              <ContractProvider>
                <ContractRoute isAdmin={false} />
              </ContractProvider>
            }
          />
        </Route>
        <Route path={ROUTES.SETTLEMENT_DETAILS} element={<PrivateRoute />}>
          <Route
            path={ROUTES.SETTLEMENT_DETAILS}
            element={
              <ContractProvider>
                <SettlementDetails />
              </ContractProvider>
            }
          />
        </Route>
        <Route path={ROUTES.SETTINGS} element={<PrivateRoute />}>
          <Route path={ROUTES.SETTINGS} element={<BusinessSettings />} />
        </Route>
        <Route path={ROUTES.USERS_MANAGEMENT} element={<PrivateRoute />}>
          <Route path={ROUTES.USERS_MANAGEMENT} element={<BusinessUsers />} />
        </Route>
        <Route path={ROUTES.USER_DETAILS} element={<PrivateRoute />}>
          <Route path={ROUTES.USER_DETAILS} element={<BusinessUserProfile />} />
        </Route>
      </Routes>
    </Suspense>
  );
};
